import React from 'react';
import StyledDiv from './styles';
import PropTypes from 'prop-types';
const FormItem = (props) => {
    const { children, ...rest } = props
    return (
        <StyledDiv {...rest}>
            {props.children}
        </StyledDiv>
    )
}
FormItem.propTypes = {
    marginBottom: PropTypes.number,
    flexDirection: PropTypes.string
}
FormItem.defaultProps = {
    marginBottom: 20,
    flexDirection: "column"
}
export default FormItem;


// WEBPACK FOOTER //
// ./src/components/FormItem/index.js